import { Identifier } from 'src/types/utilityTypes';
import api from 'src/utils/ajax';

import { Reminder } from './_types';
import { denormalizeReminder, normalizeReminder } from './normalizers';

interface FetchRemindersOptions {
  fetchAll?: boolean;
  userId?: Identifier;
  sort?: string;
  customType?: string;
}

export const fetchReminders = async ({
  fetchAll,
  userId,
  sort = 'created_at desc',
  customType,
}: FetchRemindersOptions): Promise<Reminder[]> => {
  const response = await api.get('/api/v3/reminders', {
    params: {
      fetch_all: fetchAll,
      user_id: userId,
      q: {
        ...(sort && { s: sort }),
        ...(customType && { custom_type_eq: customType }),
      },
    },
  });

  return response.data.map(normalizeReminder);
};

export const createReminder = async (reminder: Reminder): Promise<Reminder> => {
  const response = await api.post('/api/v3/reminders', {
    reminder: denormalizeReminder(reminder),
  });
  return normalizeReminder(response.data);
};

export const deleteReminder = async (
  reminderId: Reminder['id']
): Promise<void> => {
  await api.delete(`/api/v3/reminders/${reminderId}`);
};

export const updateReminder = async (
  reminder: Partial<Reminder>
): Promise<Reminder> => {
  const response = await api.put(`/api/v3/reminders/${reminder.id}`, {
    reminder: denormalizeReminder(reminder),
  });
  return normalizeReminder(response.data);
};
